import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Sentry from '@sentry/react';
import type { FC } from 'react';

import { SideBar, ToasterManager } from '@wf/components';
import { setThemeParams } from '@wf/themes';
import { AppLayout } from '@wf/sw-ui-kit';

import ErrorBoundary from '../ErrorBoundary';
import Router from '../Router';

import { APP_NAME, lpcoAbbreviation } from '../../constants';
import routes from '../../constants/routes';

import {
  COUNTRY,
  IS_DEV,
  MENU_PROVIDER_SERVICE_URL,
  PUBLIC_PATH,
  SUPPORTED_LANGUAGES,
  TRADE_PORTAL_URL,
} from '../../config';
import { isComponentPerformanceMonitoringEnabled } from '../../configs/sentry';
import { getConfigsApi } from '../../store/configs/actions';

setThemeParams(COUNTRY);

const App: FC = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getConfigsApi());
  }, [dispatch]);

  return (
    <ErrorBoundary>
      <AppLayout
        defaultMenu={routes.map(({ nature, name }) => (
          <SideBar.MenuItem title={name} linkComponent={NavLink} linkTo={nature} icon="ic_licence" key={nature}>
            {t(name)}
          </SideBar.MenuItem>
        ))}
        supportedLanguages={(SUPPORTED_LANGUAGES || '').split(',')}
        menuProviderURL={MENU_PROVIDER_SERVICE_URL}
        defaultOpenSubMenus={[t(lpcoAbbreviation)]}
        tradePortalURL={TRADE_PORTAL_URL}
        publicPath={PUBLIC_PATH}
        appName={APP_NAME}
        isDev={IS_DEV}
      >
        <Router />
        <ToasterManager />
      </AppLayout>
    </ErrorBoundary>
  );
};

export default isComponentPerformanceMonitoringEnabled ? Sentry.withProfiler(App) : App;
